module.exports = __webpack_public_path__ + "img/contact-us-banner.d438f26a.svg";